import { render } from "./PopupNotification.vue?vue&type=template&id=c8dfc842&scoped=true"
import script from "./PopupNotification.vue?vue&type=script&lang=js"
export * from "./PopupNotification.vue?vue&type=script&lang=js"

import "./PopupNotification.vue?vue&type=style&index=0&id=c8dfc842&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8dfc842"]])

export default __exports__